import { getUserToken } from "../helpers/authHelper";
import api from "../api";

export async function GetDepartmentList(data) {
  return await api({
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/department/department-list?search=${data}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-Lang_id": localStorage.getItem("lang_id") || "",
    },
  });
}

export async function CreateDepartmentData(data) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/department/create-department/`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
    "content-type": "multipart/form-data",
  });
}

export async function GetDepartmentSingleRow(id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/department/get-department-row/${id}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-Lang_id": localStorage.getItem("lang_id") || "",
    },
  });
}

export async function UpdateDepartmentData(data, id) {
  console.log("UpdateDepartmentData", id);

  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/department/update-department/${id}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-Lang_id": localStorage.getItem("lang_id") || "",
    },
  });
}

export async function DeleteRecords(id) {
  // console.log('bannerServices:60',id); return false;
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/department/delete-record/${id}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}
